'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _citiesTranslations = require('../../../translations/cities/citiesTranslations');var _citiesTranslations2 = _interopRequireDefault(_citiesTranslations);
var _getLocalizedData2 = require('../../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _HeaderDesktop = require('../HeaderDesktop.scss');var styles = _interopRequireWildcard(_HeaderDesktop);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

HeaderMainLinkDropdown = function (_Component) {_inherits(HeaderMainLinkDropdown, _Component);function HeaderMainLinkDropdown() {var _temp, _this, _ret;_classCallCheck(this, HeaderMainLinkDropdown);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    getDropdown = function () {
      switch (_this.props.main) {
        case 'buy':return true;
        case 'rent':return true;

        default:return false;}

    }, _this.

    renderLinks = function () {return _citiesTranslations2.default.map(function (item) {var _cx;var _this$props =
        _this.props,locale = _this$props.locale,translate = _this$props.translate,routeData = _this$props.routeData,option = _this$props.option;

        var tags = (0, _get2.default)(_this.props, 'routeData.tags', []);
        var isActive = tags[0] === item.name && routeData.optionType === option;var _getLocalizedData =
        (0, _getLocalizedData3.default)(item.localisation, locale),result = _getLocalizedData.result;
        var content = '\n      ' +
        translate('SEOsearch', 'apartments') + '\n      ' +
        translate('SEOsearch', 'optionType', option) + '\n      ' +
        translate('SEOsearch', 'in') + result + '\n    ';


        return (
          _react2.default.createElement(_reactRouter.Link, {
              onClick: _this.props.closeDropdown,
              to: (0, _appendLocale2.default)(locale, '/homes/' + option + '/' + item.name),
              className: (0, _classnames2.default)(
              styles.link, (_cx = {}, _cx[
              styles.activeLink] = isActive, _cx)),

              key: item.name },

            content));


      });}, _this.

    renderTitle = function () {var _cx2;var _this$props2 =







      _this.props,routeData = _this$props2.routeData,translate = _this$props2.translate,location = _this$props2.location,options = _this$props2.options,locale = _this$props2.locale,option = _this$props2.option;

      var title = option === 'buy' ? 'titleBuy' : 'titleRent';

      return (
        _react2.default.createElement('div', { className: styles.titleWrapper },
          _react2.default.createElement(_reactRouter.Link, {
              className: (0, _classnames2.default)(
              styles.title, (_cx2 = {}, _cx2[
              styles.activeLink] = _this.props.checkIsActiveLink(location, option, routeData), _cx2)),

              onClick: _this.props.closeDropdown,
              to: {
                pathname: (0, _appendLocale2.default)(locale, '/' + location + (option ? '/' + option : '')),
                state: Object.assign({},
                routeData, {
                  favorites: false,
                  optionType: option,
                  location: location },
                options) } },



            translate('SEOsearch', title))));



    }, _this.

    renderShortTermRent = function () {var _this$props3 =







      _this.props,routeData = _this$props3.routeData,translate = _this$props3.translate,location = _this$props3.location,options = _this$props3.options,locale = _this$props3.locale,option = _this$props3.option;

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_reactRouter.Link, {
              className: (0, _classnames2.default)(styles.title, styles.rentShort),
              onClick: _this.props.closeDropdown,
              to: {
                pathname: (0, _appendLocale2.default)(locale, '/homes/rent-short'),
                state: Object.assign({},
                routeData,
                options, {
                  favorites: false,
                  optionType: 'rent-short',
                  location: location }) } },



            translate('SEOsearch', 'rent-short'))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}HeaderMainLinkDropdown.prototype.

  render = function render() {
    if (this.getDropdown()) {
      return (
        _react2.default.createElement('div', { className: styles.dropdownWrapper },
          _react2.default.createElement('div', { className: styles.dropdownContent },
            _react2.default.createElement('div', { className: styles.rentShortWrapper },
              this.renderTitle(),
              this.props.main === 'rent' && this.renderShortTermRent()),

            _react2.default.createElement('div', { className: styles.linksWrapper },
              this.renderLinks()))));




    }

    return null;
  };return HeaderMainLinkDropdown;}(_react.Component);exports.default = HeaderMainLinkDropdown;


HeaderMainLinkDropdown.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  location: _propTypes2.default.string,
  option: _propTypes2.default.string,
  options: _propTypes2.default.object,
  route: _propTypes2.default.string,
  routeData: _propTypes2.default.object,
  closeDropdown: _propTypes2.default.func,
  checkIsActiveLink: _propTypes2.default.func,
  main: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderDesktop/components/HeaderMainLinkDropdown.js
// module id = 2652
// module chunks = 0